import { configureStore, combineReducers } from "@reduxjs/toolkit";
import methodDiscoveryReducer, {
  MethodDiscoveryState
} from "./reducers/methodDiscoveryReducer";
import farmDetailsReducer, {
  FarmDetailsState
} from "./reducers/farmDetailsReducer";
import queriesReducer, { Queries } from "./reducers/queries";
import isLoadingReducer, { Request } from "./reducers/loadingReducer";

export type StoreState = {
  loading: Request[];
  farmDetails: FarmDetailsState;
  methodDiscovery: MethodDiscoveryState;
  queries: Queries;
};

const rootReducer = combineReducers<StoreState, any>({
  loading: isLoadingReducer,
  farmDetails: farmDetailsReducer,
  methodDiscovery: methodDiscoveryReducer,
  queries: queriesReducer
});

const store = configureStore({
  reducer: rootReducer,
  devTools: !import.meta.env.PROD
});

export type RootState = ReturnType<typeof rootReducer>;

export default store;
